module.exports = __webpack_public_path__ + "media/images/logo-512x512-caeaa32b2ca0f952f5ab9d7d77f1ec5a.png";